import { Injectable, Optional, Inject, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LandingPage } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class LandingPagesService {
  private BASE_URL = inject(BASE_URL, { optional: true }) || '';
  private http = inject(HttpClient);

  getPages() {
    return this.http.get<LandingPage[]>(`${this.BASE_URL}api/landingpages`);
  }

  getPageBySlug(slug: string) {
    return this.http.get<LandingPage>(`${this.BASE_URL}api/landingpage/${slug}`);
  }

  getPageById(id: number) {
    return this.http.get<LandingPage>(`${this.BASE_URL}api/landingpage/${id}`);
  }
}
